// Compliance Certifications API (Feature 4)
import api, { type AxiosResponse } from './client';
import type { ComplianceCertification } from './types';

export const complianceAPI = {
  // List certifications
  list: (params?: Record<string, string | number>): Promise<AxiosResponse<{ results: ComplianceCertification[] }>> =>
    api.get('/core/compliance-certifications/', { params }),

  // Get certification details
  get: (id: number): Promise<AxiosResponse<ComplianceCertification>> =>
    api.get(`/core/compliance-certifications/${id}/`),

  // Create certification
  create: (data: FormData | Partial<ComplianceCertification>): Promise<AxiosResponse<ComplianceCertification>> =>
    api.post('/core/compliance-certifications/', data),

  // Update certification
  update: (id: number, data: FormData | Partial<ComplianceCertification>): Promise<AxiosResponse<ComplianceCertification>> =>
    api.patch(`/core/compliance-certifications/${id}/`, data),

  // Delete certification
  delete: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/core/compliance-certifications/${id}/`),
};
